import React from 'react';
import styles from './index.module.less';
import PureBreadcrumbs, { PureBreadcrumbsItem } from '@base/lib/PureBreadcrumbs';

export type BreadcrumbsProps = {
    list: PureBreadcrumbsItem[];
};

const Breadcrumbs: React.FC<BreadcrumbsProps> = ({ list }) => {
    return (
        <PureBreadcrumbs
            list={list}
            className={styles.breadcrumbs}
        />
    )
};

export default Breadcrumbs;